/* eslint-disable jsx-a11y/alt-text */
import Navigation from './Navigation';
import * as styles from './styles';

function Menubar() {
  return <Navigation css={styles.nav} />;
}

export default Menubar;
